export default __webpack_public_path__ + "static/monica-cropped-bg-0395df8bcf3eebd9124ca4aa01cb1413.png";